import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AppLogo from '../../shared/icons/logo2.png';
// import { ReactComponent as MonthlyReportIcon } from '../../shared/icons/monthly-report-icon.svg';
import { ReactComponent as EmployeesIcon } from '../../shared/icons/employees-icon.svg';
import { ReactComponent as ProfileIcon } from '../../shared/icons/profile-icon.svg';
import { ReactComponent as UploadIcon } from '../../shared/icons/upload-icon.svg';
import { ReactComponent as MissedFilesIcon } from '../../shared/icons/missed-files-icon.svg';
import { ReactComponent as SalaryIcon } from '../../shared/icons/salary-icon.svg';

import Text from '../../containers/Text';
import { GiHamburgerMenu } from 'react-icons/gi';
import {
  AiOutlineHome,
  AiOutlineCustomerService,
} from 'react-icons/ai';

import './Menu.scss';
import { Link } from 'react-router-dom';
import useWindowDimensions from '../../hooks/windowResize';
import { useHistory } from 'react-router-dom';
import useOutsideClick from '../../hooks/outsideClick';
import { SessionStorageService } from '../../shared/services/session-storage';
import { Routes } from "../../api/routes";
import { Divider, Popper, ClickAwayListener } from "@material-ui/core";
import { FileText, Receipt, Info, Mail, History, ListChecks, Settings } from 'lucide-react';

const Menu = ({
  menuClassName,
  handleDrawer,
  user,
  currentLng,
  changeLanguage,
  setLanguage,
  activePage,
  refreshContent
}) => {
  const { t } = useTranslation();
  const { screenWidth } = useWindowDimensions();
  const userName = [user?.firstName, user?.lastName].filter(Boolean).join(' ');

  const setNewLanguage = (lng) => {
    changeLanguage(lng);
    SessionStorageService.setAppLanguage(lng);
    setLanguage({ language: lng });
  };

  const history = useHistory();

  const menuRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeId, setActiveId] = useState(null);

  function redirectToHome() {
    history.push('/');
  }

  const handleMenu = () => {
    if (menuClassName === 'nav-bar') {
      handleDrawer();
    }
  };

  const clickOnMenuItem = (url) => {
    if (window.location.pathname === url) {
      refreshContent();
    } else
      handleDrawer();
  };

  useOutsideClick(menuRef, handleMenu);

  const renderInquiryItemWithTooltip = (
    to,
    icon,
    labelKey,
    tooltipKey,
    anchorId
  ) => {
    const open = activeId === anchorId;

    return (
      <div className="submenu-item-with-tooltip" key={anchorId}>
        <Link
          to={to}
          onClick={() => clickOnMenuItem(to)}
          className={activePage === to ? 'item active' : ''}
        >
          <div className="icon-div">
            {icon}
            {t(labelKey)}
          </div>
        </Link>

        <span
          className="submenu-info-icon"
          role="button"
          tabIndex={0}
          aria-label={t(tooltipKey)}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            if (open) {
              setActiveId(null);
              setAnchorEl(null);
            } else {
              setActiveId(anchorId);
              setAnchorEl(e.currentTarget);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
              e.preventDefault();
              e.stopPropagation();

              if (open) {
                setActiveId(null);
                setAnchorEl(null);
              } else {
                setActiveId(anchorId);
                setAnchorEl(e.currentTarget);
              }
            }
          }}
        >
          <Info className="monthly-icon" size={16} />
        </span>

        <Popper
          open={open}
          anchorEl={anchorEl}
          placement={currentLng === 'heb' ? 'left' : 'right'}
          style={{ zIndex: 1000 }}
        >
          <ClickAwayListener
            onClickAway={() => {
              setActiveId(null);
              setAnchorEl(null);
            }}
          >
            <div className="popper">
              {t(tooltipKey)}
            </div>
          </ClickAwayListener>
        </Popper>
      </div>
    );
  };

  return (
    <div className="menu-container" ref={menuRef}>
      <div className={menuClassName}>
        {screenWidth > 600 && (
          <div className="nav-bar-header">
            <Text
              text={
                <img
                  src={AppLogo}
                  onClick={redirectToHome}
                  className="app-logo"
                  alt="app logo"
                />
              }
            />
            <GiHamburgerMenu
              size={35}
              className={`nav-bar-icon`}
              onClick={handleDrawer}
            />
          </div>
        )}
        <div className="buttons-container">
          <Link
            onClick={() => clickOnMenuItem('/')}
            className={activePage === '/' ? 'home-page active' : 'home-page'}
            to={'/'}
          >
            <AiOutlineHome className="menu-icon" />
            <Text text={t('home-page')} />
          </Link>

          {user.role === 'admin' && <>
            <Link
              onClick={() => clickOnMenuItem(Routes.accounts)}
              className={
                activePage === Routes.accounts
                  ? 'admin-menu-item active'
                  : 'admin-menu-item'
              }
              to={Routes.accounts}
            >
              <EmployeesIcon className="menu-icon" />
              <Text text={t('accounts')} />
            </Link>
            <Link
              onClick={() => clickOnMenuItem(Routes.salaries)}
              className={
                activePage === Routes.salaries
                  ? 'admin-menu-item active'
                  : 'admin-menu-item'
              }
              to={Routes.salaries}
            >
              <SalaryIcon className="menu-icon" />
              <Text text={t('salaries')} />
            </Link>
            <Link
              onClick={() => clickOnMenuItem(Routes.salaryActions)}
              className={
                activePage === Routes.salaryActions
                  ? 'admin-menu-item active'
                  : 'admin-menu-item'
              }
              to={Routes.salaryActions}
            >
              <Settings className="menu-icon menu-icon-stroke" />
              <Text text={t('salary-actions')} />
            </Link>
            <Link
              onClick={() => clickOnMenuItem('/missed')}
              className={
                activePage === '/missed' ? 'admin-menu-item active' : 'admin-menu-item'
              }
              to={'/missed'}
            >
              <MissedFilesIcon className="menu-icon" />
              <Text text={t('missed-files')} />
            </Link>

            <Link
              onClick={() => clickOnMenuItem(Routes.emailTrackingReport)}
              className={
                activePage === Routes.emailTrackingReport
                  ? 'admin-menu-item active'
                  : 'admin-menu-item'
              }
              to={Routes.emailTrackingReport}
            >
              <Mail className="menu-icon menu-icon-stroke" />
              <Text text={t('email-tracking-report-title')} />
            </Link>

            <Link
              onClick={() => clickOnMenuItem(Routes.authHistory)}
              className={
                activePage === Routes.authHistory
                  ? 'admin-menu-item active'
                  : 'admin-menu-item'
              }
              to={Routes.authHistory}
            >
              <History className="menu-icon menu-icon-stroke" />
              <Text text={t('auth-history-report-title')} />
            </Link>

            <Link
              onClick={() => clickOnMenuItem('/files-upload')}
              className={
                activePage === '/files-upload'
                  ? 'admin-menu-item active'
                  : 'admin-menu-item'
              }
              to={'/files-upload'}
            >
              <UploadIcon className="menu-icon" />
              <Text text={t('upload-files')} />
            </Link>
            <div style={{ marginTop: '10px' }}>
            
            </div>
          </>}

          {/*<Link*/}
          {/*  onClick={() => clickOnMenuItem(Routes.monthlyReport)}*/}
          {/*  className={*/}
          {/*    activePage === Routes.monthlyReport*/}
          {/*      ? 'menu-item active'*/}
          {/*      : 'menu-item'*/}
          {/*  }*/}
          {/*  to={Routes.monthlyReport}*/}
          {/*>*/}
          {/*  <MonthlyReportIcon className="menu-icon"/>*/}
          {/*  <Text text={t('monthly-report')}/>*/}
          {/*</Link>*/}

          {user.role === 'admin' ? (
            <>
              <Divider />
              <div
              >

                <div className='monthly-overview-title'>
                  <Text text={t('all-files')} />
                </div>
              </div>
              <div>
                <div className="submenu">
                  <Link to="/admin-panel/invoices">
                    <div className='icon-div'>
                      <FileText className="monthly-icon" />
                      {t('invoices')}
                    </div>
                  </Link>
                  <Link to="/admin-panel/receipts">
                    <div className='icon-div'>
                      <FileText className="monthly-icon" />
                      {t('receipts')}
                    </div>
                  </Link>
                  <Link to="/admin-panel/salaries">
                    <div className='icon-div'>
                      <FileText className="monthly-icon" />
                      {t('salaries')}
                    </div>
                  </Link>
                  <Link to="/admin-panel/general-documents">
                    <div className='icon-div'>
                      <FileText className="monthly-icon" />
                      {t('general-docs')}
                    </div>
                  </Link>
                </div>
              </div>
            </>
          ) : (
            <>
              <div>
                <div className='monthly-overview-title'>
                  <Text text={t('monthly-overview')} />
                </div>
                <div className="submenu">
                  <Link to="/monthly-overview/invoices"
                    onClick={() => clickOnMenuItem('/monthly-overview/invoices')}
                    className={
                      activePage === '/monthly-overview/invoices' ? 'item active' : ''
                    }>
                    <div className='icon-div'>
                      <FileText className="monthly-icon" />
                      {t('invoices')}
                    </div>
                  </Link>
                  <Link to="/monthly-overview/receipts"
                    onClick={() => clickOnMenuItem('/monthly-overview/receipts')}
                    className={
                      activePage === '/monthly-overview/receipts' ? 'item active' : ''
                    }>
                    <div className='icon-div'>
                      <FileText className="monthly-icon" />
                      {t('receipts')}
                    </div>
                  </Link>
                  <Link to="/monthly-overview/salaries"
                    onClick={() => clickOnMenuItem('/monthly-overview/salaries')}
                    className={
                      activePage === '/monthly-overview/salaries' ? 'item active' : ''
                    }>
                    <div className='icon-div'>
                      <FileText className="monthly-icon" />
                      {t('salaries')}
                    </div>
                  </Link>
                  <Link to={Routes.generalDocuments}
                    onClick={() => clickOnMenuItem(Routes.generalDocuments)}
                    className={
                      activePage === Routes.generalDocuments ? 'item active' : ''
                    }>
                    <div className='icon-div'>
                      <FileText className="monthly-icon" />
                      {t('general-docs')}
                    </div>
                  </Link>
                </div>
              </div>

            </>
          )}
          <div>
            <div className='inquiries-title'>
              <Text text={t('inquiries-title')} />
            </div>
            <div className="submenu">
              <Link
                to={Routes.myRequests}
                onClick={() => clickOnMenuItem(Routes.myRequests)}
                className={activePage === Routes.myRequests ? 'item active' : ''}
              >
                <div className="icon-div">
                  <ListChecks className="icon my-requests-icon" />
                  {user?.role === 'admin'
                    ? t('all-requests-title')
                    : t('my-requests-title')}
                </div>
              </Link>
              {renderInquiryItemWithTooltip(
                Routes.invoiceRequest,
                <FileText className="icon invoice-request-icon" />,
                'invoice-request-title',
                'invoice-request-description',
                'invoice-request'
              )}
              {renderInquiryItemWithTooltip(
                Routes.expenseRequest,
                <Receipt className="icon expense-request-icon" />,
                'expense-request-title',
                'expense-request-description',
                'expense-request'
              )}
              {renderInquiryItemWithTooltip(
                Routes.serviceCall,
                <AiOutlineCustomerService className="icon service-call-icon" />,
                'service-call-title',
                'service-call-description',
                'service-call'
              )}
            </div>
          </div>
             
          <Divider className='space' />

          <div className="profile-title">
            <Text text={t('profile')} />
          </div>
          <div className="submenu">
            <Link
              onClick={() => clickOnMenuItem('/user-page')}
              to={`/user/${user.id}`}
              className={
                (activePage === '/user-page'
                  ? 'menu-item active'
                  : 'menu-item')
              }
            > <div className='icon-div'>
                <ProfileIcon className="profile-icon" />
                <Text text={userName} />
              </div>
            </Link>
          </div>


        </div>
        <div className="nav-bar-footer">

          <div className="lng-change-wrapper">
            <div className="lng-change-container">
              {currentLng === 'heb' ? (
                <>
                  <button
                    onClick={() => setNewLanguage('heb')}
                    className={`lng-button ${currentLng === 'heb' ? 'item active-btn' : ''}`}
                  >
                    <Text text={t('heb-lang-button')} />
                  </button>
                  <button
                    onClick={() => setNewLanguage('en')}
                    className={`lng-button ${currentLng === 'en' ? 'item active-btn' : ''}`}
                  >
                    <Text text={t('eng-lang-button')} />
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => setNewLanguage('en')}
                    className={`lng-button ${currentLng === 'en' ? 'item active-btn' : ''}`}
                  >
                    <Text text={t('eng-lang-button')} />
                  </button>
                  <button
                    onClick={() => setNewLanguage('heb')}
                    className={`lng-button ${currentLng === 'heb' ? 'item active-btn' : ''}`}
                  >
                    <Text text={t('heb-lang-button')} />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default Menu;
